import { render, staticRenderFns } from "./communityBactivity.vue?vue&type=template&id=1c1f4d92&scoped=true"
import script from "./communityBactivity.vue?vue&type=script&lang=js"
export * from "./communityBactivity.vue?vue&type=script&lang=js"
import style0 from "./communityBactivity.vue?vue&type=style&index=0&id=1c1f4d92&prod&scoped=true&lang=css"
import style1 from "./communityBactivity.vue?vue&type=style&index=1&id=1c1f4d92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1f4d92",
  null
  
)

export default component.exports